import './styles/RequiredSelect.scss';
import CoreComponent from './CoreComponent';
import React, { Suspense } from 'react';

let SelectModes = {
    // See https://react-select.com/home for more options
    default: () => import('react-select'),
    async: () => import('react-select/async'), // AJAX Support
    createable: () => import('react-select/creatable'), // Creatable Select
    asyncCreateable: () => import('react-select/async-creatable'), // Async + Creatable
}

function Fallback({ parent, props, required, disabled }) {
    return (
        props.options?.length >= 1 ?
            <select
                required={required}
                disabled={disabled}
                className="fallback"
                onChange={
                    (event) => parent?.onChange?.(props.options?.find((opt) => opt?.value == event.target.value))
                }
                defaultValue={parent?.value?.() || parent.props?.defaultValue || parent.props?.value || '_default'}
            >
                <option
                    value="_default"
                    disabled="disabled"
                >
                    {props.placeholder || 'Select...'}
                </option>
                {
                    props.options?.map((opt, idx) => {
                        return (
                            <option
                                key={idx}
                                value={opt?.value}
                            >
                                {opt?.label}
                            </option>
                        )
                    })
                }
            </select>
            :
            <div className="fallback-message">
                {props.fallback || 'Warning: selector failed to load!'}
            </div>
    )
}

class RequiredSelect extends CoreComponent {
    constructor(props) {
        super(props)
        this.state = {
            value: this.value?.(props.value || {}),
            open: props.defaultMenuIsOpen || false,
        }
        this.Selector = React.lazy(SelectModes[SelectModes[props.mode] instanceof Function ? props.mode : 'default']);
    }

    value(value = this.state.value) {
        return this.props?.getValue?.(value) || value?.value || value?.label || (Array.isArray(value) || value === Object(value) ? JSON.stringify(value) : '');
    }

    onChange(value) {
        this.setStatePrev({ value }).then(() => {
            ((this.props.inputRef || {}).current || {}).value = this.value(value);
            this.props.onChange?.(value)
        })
    }

    handleOpenChange(open) {
        this.setStatePrev({ open }).then(() => {
            this.props?.[open ? 'onMenuOpen' : 'onMenuClose']?.()
        });
    }

    render() {
        var {
            required = true,
            disabled,
            className = '',
            ...props
        } = this.props;

        return (
            <div className="RequiredSelect" style={{ zIndex: this.state.open ? 99999 : 'auto' }} >
                <Suspense fallback={
                    <Fallback parent={this} props={props} required={required} disabled={disabled} />
                }>
                    <this.Selector
                        {...props}

                        onChange={(value) => this.onChange(value)}
                        className={`${className} selector`}
                        onMenuOpen={() => this.handleOpenChange(true)}
                        onMenuClose={() => this.handleOpenChange(false)}
                    />
                </Suspense>
                <input
                    className='value'
                    type="text"
                    tabIndex={-1}
                    autoComplete="off"
                    defaultValue={this.value()}
                    required={required}
                    disabled={disabled}
                    onChange={() => { }}
                    ref={props.inputRef || null}
                />
            </div>
        )
    }
}

class LazySelect extends CoreComponent {
    constructor(props) {
        super(props)
        this.state = {
            value: this.value?.(props.value || {}),
        }
        this.Selector = React.lazy(SelectModes[SelectModes[props.mode] instanceof Function ? props.mode : 'default']);
    }

    onChange(value) {
        this.setStatePrev({ value }).then(() => {
            this.props.onChange?.(value)
        })
    }

    render() {
        var {
            disabled,
            className,
            ...props
        } = this.props;

        return (
            <div className="LazySelect">
                <Suspense fallback={
                    <Fallback parent={this} props={props} disabled={disabled} />
                }>
                    <this.Selector
                        {...props}
                        onChange={(value) => this.onChange(value)}
                        className={`${className} selector`}
                    />
                </Suspense>
            </div>
        )
    }
}

export {
    RequiredSelect as default,
    RequiredSelect,
    LazySelect,
}